import script from "./Units.vue?vue&type=script&setup=true&lang=ts"
export * from "./Units.vue?vue&type=script&setup=true&lang=ts"

import "./Units.vue?vue&type=style&index=0&id=3be7c809&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be7c809"]])

export default __exports__